import { render, staticRenderFns } from "./AdSenseFeed.vue?vue&type=template&id=6ded18f0&scoped=true&"
import script from "./AdSenseFeed.vue?vue&type=script&lang=js&"
export * from "./AdSenseFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded18f0",
  null
  
)

export default component.exports